import React, { useState, useEffect } from "react";
import {
  Avatar,
  Box,
  Button,
  Chip,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import CloseIcon from "@mui/icons-material/Close";
import bkstApi from "../../api";
import NothingFound from "../search/NothingFound";
import LoyaltyStatus from "../component/LoyaltyStatus";
import { formatPhoneNumber } from "../util";
import BakerOrderSummary from "../../baker/components/BakerOrderSummary";
import BakerQuoteSummary from "../../baker/components/BakerQuoteSummary";
import { useContext } from "react";
import { UserContext } from "../../context/UserContext";
import CustomerSpend from "../../customer/component/CustomerSpend";
import { Link as RouterLink } from "react-router-dom";

export default function CustomerDetailsButton(props) {
  const { user } = useContext(UserContext);

  const [customer, setCustomer] = useState(props.customer || "");
  const [loading, setLoading] = useState(true);

  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState(0);

  useEffect(() => {
    bkstApi(`/my/customer/${customer.id}`).then((res) => {
      setCustomer(res.data.customer);
      setLoading(false);
    });
  }, [customer?.id]);

  let hasManagerAccess = user.role === "owner" || user.role === "manager";
  let hasQuoteAccess = hasManagerAccess || user.role === "clerk";

  return (
    <>
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          cursor: "pointer",
          gap: "3px",
          textDecoration: "none",
          color: "inherit",
        }}
        onClick={() => setOpen(true)}
      >
        <IconButton size="small">
          <PermIdentityOutlinedIcon />
        </IconButton>
        <Typography variant="body2">
          {customer.firstName} {customer.lastName}{" "}
          {customer.type === "commercial" ? (
            <Chip size="small" label="commercial" color="info" />
          ) : (
            customer?.loyaltyLevel && <LoyaltyStatus status={customer.loyaltyLevel} />
          )}
        </Typography>
      </Box>
      <Dialog onClose={() => setOpen(false)} open={open} fullWidth={true} maxWidth="sm">
        <DialogTitle sx={{ margin: 0 }}>
          <Box sx={{ display: "flex", gap: "15px" }}>
            <Box>
              <Avatar sx={{ width: 56, height: 56, bgcolor: "#333" }}>
                {customer.firstName?.[0]}
                {customer.lastName?.[0]}
              </Avatar>
            </Box>
            <Box sx={{ flexGrow: "1" }}>
              <Typography variant="h5">
                {customer.firstName} {customer.lastName}{" "}
                {customer?.loyaltyLevel && <LoyaltyStatus status={customer.loyaltyLevel} />}
              </Typography>
              <CustomerSpend customer={customer} hasManagerAccess={hasManagerAccess} />
              <Typography variant="overline" color="textSecondary" display="block">
                {formatPhoneNumber(customer.phone)}
              </Typography>
              <Box mt={1}>
                <Button
                  size="small"
                  variant="outlined"
                  color="secondary"
                  component={RouterLink}
                  to={`/customer/${customer.id}`}
                >
                  View Profile
                </Button>
              </Box>
            </Box>
          </Box>
          <IconButton
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{ minHeight: "90vh", backgroundColor: "#ECECEC", padding: 0, margin: 0 }}
        >
          <Container maxWidth="sm">
            <Box my={2}>
              <Box>
                <Tabs value={tab} sx={{ borderBottom: "1px solid #ECECEC" }}>
                  {customer.phone && <Tab key={0} label={"Orders"} onClick={() => setTab(0)} />}
                  {hasQuoteAccess && customer.phone && (
                    <Tab key={1} label={"Quotes"} onClick={() => setTab(1)} />
                  )}
                </Tabs>
              </Box>
              {tab === 0 && (
                <Box>
                  {customer.orders && customer.orders.length > 0 ? (
                    customer.orders
                      ?.sort((o1, o2) => o2.fulfillment.date.localeCompare(o1.fulfillment.date))
                      .map((order) => {
                        return <BakerOrderSummary key={order.id} order={order} showTs={true} />;
                      })
                  ) : (
                    <NothingFound />
                  )}
                </Box>
              )}
              {tab === 1 && (
                <Box>
                  {customer.quotes && customer.quotes.length > 0 ? (
                    customer.quotes
                      ?.sort((o1, o2) => o2.date.localeCompare(o1.date))
                      .map((request, idx) => {
                        return <BakerQuoteSummary key={idx} request={request} />;
                      })
                  ) : (
                    <NothingFound />
                  )}
                </Box>
              )}
            </Box>
          </Container>
        </DialogContent>
      </Dialog>
    </>
  );
}
